import React from 'react';
// components
import InfoTileV2 from '@zola/zola-ui/src/components/PreAuth/InfoTileV2';
import CTAV2 from '@zola/zola-ui/src/components/PreAuth/CTAV2';
import Carousel from '~/components/ui/Carousel';
// util
import { MOBILE_MAX, TABLET_MIN, TABLET_MAX, DESKTOP_MIN } from '~/libs/universal/utils/device';
import { desktopOnly, excludeDesktop } from '@zola/zola-ui/src/styles/emotion/mixins/responsive';
import _chunk from 'lodash/chunk';
// styles
import containerStyles from '~/styles/landingPageShared.module.less';
import styles from './EverythingYouAndGuestsWant.module.less';
// content
import infoTilesContent from './tileContent';

const infoTileArr = infoTilesContent.map((tile, i) => (
  <CTAV2 key={i + 1} href={tile.href} arrow={false} rel="noopener noreferrer">
    <InfoTileV2
      key={`registry-info-tile-${i}`}
      className={styles.infoTile}
      heading={tile.heading}
      imgSrc={tile.imgSrc}
      imgAlt={tile.imgAlt}
      displayAsColumn
    />
  </CTAV2>
));

const EverythingYouAndGuestsWant: React.FC = () => {
  const responsiveOverride = {
    desktop: {
      breakpoint: { max: 10000, min: DESKTOP_MIN },
      items: 4,
      slidesToSlide: 4,
    },
    tablet: {
      breakpoint: { max: TABLET_MAX, min: TABLET_MIN },
      items: 2,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: MOBILE_MAX, min: 0 },
      items: 2,
      slidesToSlide: 2,
    },
  };

  return (
    <div className={containerStyles.centered}>
      <Carousel
        className={styles.carousel}
        responsiveOverride={responsiveOverride}
        arrowStyleOverride={styles.arrow}
        rightArrowStyleOverride={styles.rightArrow}
        leftArrowStyleOverride={styles.leftArrow}
        css={excludeDesktop}
      >
        {_chunk(infoTileArr, 2).map(tileChunk => (
          <div className={styles.infoTileColumn}>{tileChunk}</div>
        ))}
      </Carousel>
      <Carousel
        className={styles.carousel}
        responsiveOverride={responsiveOverride}
        arrowStyleOverride={styles.arrow}
        rightArrowStyleOverride={styles.rightArrow}
        leftArrowStyleOverride={styles.leftArrow}
        css={desktopOnly}
      >
        {infoTileArr}
      </Carousel>
    </div>
  );
};

export default EverythingYouAndGuestsWant;
